function Background(){
    return(
    <>
    <div id="backgroundTecno" style={{height: "100vh", width: "100%", overflow:"hidden", position: "fixed"}}>
        <video autoPlay muted loop playsInline style={{height: "100%", width: "100%", objectFit: "cover"}}>
            <source src="/background.mp4" type="video/mp4"/>
            <source src="https://framerusercontent.com/assets/hdn2YsWs68poMpvtQ0jEQrJD76I.mp4"/>
        </video>
    </div>
    </>
    )
}

export default Background